/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import ManageUserComponent from '../components/ManageUserComponent'
import { connect } from 'react-redux'
import { userActions } from '../_actions'
import PropTypes from 'prop-types'

import { Growl } from 'primereact/growl'
import { getLoader } from '../_common/utils'


function ManageUserContainer({ userList, getUserByPage, totalRecords, isUserLoading, activeUser, activeData, clearAllMessages }) {
  const growl = useRef(null)
  useEffect(() => {
    if (activeData.message === 'activated') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Activated Successfully', life: 3000 })
      clearAllMessages()
    }
    if (activeData.message === 'de-activated') {
      growl.current.show({ severity: 'success', summary: '', detail: 'De-Activated Successfully', life: 3000 })
      clearAllMessages()
    }

  }, [activeData, clearAllMessages])

  return (
    <div className="p-grid pageWrapper">
      {isUserLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <ManageUserComponent
        getUserByPage={getUserByPage}
        totalRecords={totalRecords}
        userList={userList}
        activeUser={activeUser}
        activeData={activeData}
      />
    </div>
  )
}

ManageUserContainer.propTypes = {
  userList: PropTypes.array,
  getUserByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  isGetAllError: PropTypes.bool,
  isUserLoading: PropTypes.bool,
  activeUser: PropTypes.func,
  activeData: PropTypes.object,
  clearAllMessages: PropTypes.func
}
const mapStateToProps = state => {
  return {
    userList: state.users.userList ? state.users.userList : [],
    totalRecords: state.users.count,
    isGetAllError: state.users.isGetAllError,
    isUserLoading: state.users.isLoading,
    activeData: state.users.activeData ? state.users.activeData : {},

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getUserByPage: (start, pageSize, search) => dispatch(userActions.getUserByPage(start, pageSize, search)),
    activeUser: (id, isActive) => dispatch(userActions.activeUser(id, isActive)),
    clearAllMessages: () => dispatch(userActions.clearAllMessages())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserContainer)
